import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AuthGuard } from '@reg/shared/auth';
import { EventService, AuthService } from '@reg/shared/service';

/**
 * This guard is meant to be used for routes that should not be loadable
 * without authenticating with FloSports and the user has access to the given event.
 * If they do not have access to they will be redirected to an access denied page.
 */
@Injectable()
export class EventAdminAuthGuard extends AuthGuard {
    constructor(
protected eventService: EventService,
                protected authService: AuthService,
                protected router: Router,
    ) {
        super(authService, router);
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const eventId: string = route.params['event-id'] || (route.firstChild && route.firstChild.params['event-id']);

        if (super.canActivate(route, state)) {
            // const eventId: string = route.params['event-id'];

            return this.eventService.getHasAccess(eventId).pipe(map(
                (hasAccess: boolean) => {
                    if (!hasAccess) {
                        this.router.navigate(['error', 'access-denied-event']);
                    }

                    return hasAccess;
                },
            ));
        }
    }
}
